export default "https://d3nn82uaxijpm6.cloudfront.net/packs/media/apps/subscriptions/Checkout/components/Form/assets/amex-4c857f96f7bb2af2e0dcce185efce40b.svg";